import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["template", "destination"];

  copy() {
    let content = this.templateTarget.innerHTML.replace(
      /NEW_RECORD/g,
      new Date().getTime(),
    );

    if (this.hasDestinationTarget) {
      this.destinationTarget.insertAdjacentHTML("beforeend", content);
      this.#focusInput(this.destinationTarget.lastElementChild);
    } else {
      this.element.insertAdjacentHTML("beforebegin", content);
      this.#focusInput(this.destinationTarget.previousElementSibling);
    }
  }

  #focusInput(element) {
    element?.querySelector("input, textarea, select")?.focus();
  }
}
